import authorizedAPIInstance from '@/api/authorizedAPI';
import { formatAPIError } from '@/utils/helpers';

export type FetchTagValuesInput = {
  tag_ids: Array<string>;
  period_start: string;
  period_end: string;
  latest_value?: boolean;
  next_token?: string;
};

export type TagValueDataPoint = {
  timestamp: string;
  quality: string;
  value: number;
};

export type FetchTagValuesItem = {
  id: string;
  data_points: TagValueDataPoint[];
  unit: string;
  data_type: string;
  count: number;
  has_more: boolean;
  next_token: string;
};

export type FetchTagValuesError = {
  category: string;
  code: string;
  message: string;
  param: string;
};

export type FetchTagValuesResponse = {
  successes: Array<FetchTagValuesItem>;
  hasNext: boolean;
  errors: Array<FetchTagValuesError>;
};

export const fetchTagValues = async (
  params: FetchTagValuesInput
): Promise<FetchTagValuesResponse> => {
  try {
    const { data } = await authorizedAPIInstance.post<FetchTagValuesResponse>(
      '/api/tag-values',
      params
    );

    return data;
  } catch (error) {
    throw formatAPIError(error);
  }
};
